import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faUser,
  faBuilding,
  faFileAlt,
  faShieldAlt,
  faCar,
} from '@fortawesome/free-solid-svg-icons';
import quotationsAxe from '../../services/axios-client/quotationsAxeClient';
import { apiDownloadDocument } from '../../services/axios-client/axeCommons';
import {
  collisioneCompletedDataReset,
  getCollisioneCompletedData,
} from '../../features/purchases/purchasesActions';
import PageLoading from '../../common/components/elements/PageLoading';
import ErrorComponent from '../../common/components/ErrorComponent';
import { TutelaLegaleCompletedScreenStyles } from './completedScreens.styles';
import {
  CompletedCard,
  CompletedCardHeader,
  CompletedCardIcon,
  CompletedCardTitle,
  CompletedFieldGrid,
  CompletedField,
  CompletedSectionTitle,
} from './CompletedV2.styles';
import CompletedQuoteScreenAutoAfterSale from '../../common/components/elements/CompletedQuoteScreenAutoAfterSale';
import TutelaLegaleInfoModal from '../../common/components/redesignComponents/Modal/TutelaLegaleInfoModal';
import pdfIMG from '../../assets/images/purchase/pdf.png';
import downloadIMG from '../../assets/redesign_icons/download.svg';
import axe from '../../services/axios-client/axiosClient';
import { downloadFile } from '../../services/axios-client/axeHelpers';
import ContractDocuments from '../../common/components/elements/ContractDocuments';

function CollisioneCompletedScreen() {
  const { quoteId } = useParams();
  const [residenceInfo, setResidenceInfo] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const { loading, quote, error } = useSelector(
    (store) => store.purchases.tutela_legale_completed,
  );
  const { document_types } = useSelector((store) => store.afterSale);

  const collectMunicipalities = () => {
    try {
      quotationsAxe.get('/form-data/communes').then((res) => {
        const commune = res.data.data.find(
          (commune) => commune.cadastral_code
            == quote.insurance_request.customer.residence_commune_code,
        );
        setResidenceInfo(commune);
      });
    } catch (err) {
      // Do nothing
    }
  };

  const downloadResourceDocs = async (id) => {
    const res = await axe.get(`/download-resource-document/${id}/0`, {
      responseType: 'blob',
    });

    downloadFile(res.data);
  };

  const collectQuoteData = () => {
    getCollisioneCompletedData(quoteId);
  };

  const downloadDocument = async (documentId) => {
    const response = await apiDownloadDocument(documentId);
    const alink = document.createElement('a');
    alink.target = '_blank';
    alink.href = response.data.data.contents;
    alink.download = response.data.data.filename;
    alink.click();
  };

  useEffect(() => {
    collectQuoteData();

    return () => {
      collisioneCompletedDataReset();
    };
  }, [quoteId]);

  useEffect(() => {
    if (quote && quote.status === 7) {
      collectMunicipalities();
    }
  }, [quote]);

  if (loading) {
    return <PageLoading />;
  }

  if (loading === false && error !== null) {
    return <ErrorComponent error={error} />;
  }

  // const documentsRequests = [
  //   ...quote.insurance_request.document_requests.filter(
  //     (dr) => dr.document !== null,
  //   ),
  //   ...quote.document_requests.filter((dr) => dr.document !== null),
  // ];

  const documents = [...quote.insurance_request.documents, ...quote.documents];

  return (
    <>
      {showModal && (
        <TutelaLegaleInfoModal
          quotation={{
            product_name: quote.risk_information.product_name,
            massimale: quote.risk_information.massimale,
            amount: quote.amount,
            tax_total: quote.tax_total,
            information: quote.risk_information.information,
          }}
          setShowModal={setShowModal}
        />
      )}
      <TutelaLegaleCompletedScreenStyles>
        {/* Contract Documents Section */}
        <div className="section-container">
          <ContractDocuments
            downloadDocument={downloadDocument}
            insuranceRequest={quote.insurance_request}
            quote={quote}
            collectQuoteData={collectQuoteData}
            v2
          />
        </div>

        {/* Customer Information Section */}
        <div className="section-container">
          <CompletedSectionTitle>
            <FontAwesomeIcon icon={faFileAlt} className="section-icon" />
            <h2>Informazioni Polizza</h2>
          </CompletedSectionTitle>

          <div className="cards-row">
            {/* Customer Information Card */}
            <div>
              <CompletedCard className="polizze-emessa-status-step-one">
                <CompletedCardHeader>
                  <CompletedCardIcon>
                    <FontAwesomeIcon
                      icon={quote.insurance_request.customer.gender === 'G' ? faBuilding : faUser}
                    />
                  </CompletedCardIcon>
                  <CompletedCardTitle>Anagrafica</CompletedCardTitle>
                </CompletedCardHeader>

                <CompletedFieldGrid>
                  <CompletedField className="full">
                    <dt>
                      {quote.insurance_request.customer.gender === 'G' ? 'Compagnia' : 'Nome e Cognome'}
                    </dt>
                    <dd>
                      {quote.insurance_request.customer.gender === 'G'
                        ? quote.insurance_request.customer.business_name
                        : `${quote.insurance_request.customer.name} ${quote.insurance_request.customer.surname}`}
                    </dd>
                  </CompletedField>

                  <CompletedField>
                    <dt>Email</dt>
                    <dd>{quote.insurance_request.customer.email}</dd>
                  </CompletedField>

                  <CompletedField>
                    <dt>Telefono</dt>
                    <dd>{quote.insurance_request.customer.phone}</dd>
                  </CompletedField>

                  <CompletedField className="full">
                    <dt>Indirizzo</dt>
                    <dd>
                      {quote.insurance_request.customer.address}
                      ,
                      {' '}
                      {quote.insurance_request.customer.house_number}
                      ,
                      {' '}
                      {quote.insurance_request.customer.postal_code}
                    </dd>
                  </CompletedField>

                  <CompletedField>
                    <dt>Residenza</dt>
                    <dd>{residenceInfo !== null && residenceInfo.name}</dd>
                  </CompletedField>

                  <CompletedField>
                    <dt>Città</dt>
                    <dd>
                      {residenceInfo !== null && residenceInfo.communal_territory.name}
                    </dd>
                  </CompletedField>

                  <CompletedField className="full">
                    <dt>Prodotto</dt>
                    <dd>{quote.product.name}</dd>
                  </CompletedField>
                </CompletedFieldGrid>
              </CompletedCard>
            </div>
          </div>
        </div>

        {/* Quote Details Section */}
        <div className="section-container">
          <CompletedSectionTitle>
            <FontAwesomeIcon icon={faShieldAlt} className="section-icon" />
            <h2>Dettagli Preventivo e Documenti</h2>
          </CompletedSectionTitle>

          <div className="row">
            {/* Collisione Data Card */}
            <div className="col-12 col-md-6 mb-3">
              <CompletedCard className="polizze-emessa-status-step-two">
                <CompletedCardHeader>
                  <CompletedCardIcon>
                    <FontAwesomeIcon icon={faCar} />
                  </CompletedCardIcon>
                  <CompletedCardTitle>
                    Dati Collisione
                    {' '}
                    {' '}
                    {quote.product_id === 1 && quote.company_id === 1005 && '(Servizio non assicurativo)'}
                  </CompletedCardTitle>
                </CompletedCardHeader>

                <CompletedFieldGrid>
                  <CompletedField>
                    <dt>Compagnia</dt>
                    <dd>{quote.company.name}</dd>
                  </CompletedField>

                  <CompletedField>
                    <dt>Nome Prodotto</dt>
                    <dd>{quote.risk_information.product_name}</dd>
                  </CompletedField>

                  {quote.risk_information && quote.risk_information.massimale && quote.product_id != 13 && (
                    <CompletedField>
                      <dt>Massimale</dt>
                      {quote.risk_information && quote.risk_information.massimale && (
                        <dd>
                          {quote.risk_information.massimale}
                          {' '}
                          &euro;
                        </dd>
                      )}

                    </CompletedField>
                  )}

                  {quote.product_id == 13 && (
                    <CompletedField>
                      <dt>Massimale</dt>
                      <dd>
                        {parseFloat(quote.massimale).toFixed(2)}
                        {' '}
                        &euro;
                      </dd>
                    </CompletedField>
                  )}

                  <CompletedField>
                    <dt>Stato</dt>
                    <dd>{quote.status === 7 && 'Polizza Emmesa'}</dd>
                  </CompletedField>

                  <CompletedField>
                    <dt>Data Decorrenza</dt>
                    <dd>
                      {moment(quote.insurance_request.policy_effective_date)
                        .toDate()
                        .toLocaleDateString('it-IT')}
                    </dd>
                  </CompletedField>

                  <CompletedField>
                    <dt>Frequenza Pagamento</dt>
                    <dd>
                      {quote.payment_frequency === 1 ? 'Annuo' : 'Semestrale'}
                    </dd>
                  </CompletedField>

                  <CompletedField>
                    <dt>Premio</dt>
                    <dd>
                      {parseFloat(quote.amount).toFixed(2)}
                      {' '}
                      &euro;
                    </dd>
                  </CompletedField>

                  <CompletedField>
                    <dt>Pagato</dt>
                    <dd>
                      {quote.amount_paid === null
                        ? '0.00'
                        : parseFloat(quote.amount_paid).toFixed(2)}
                      {' '}
                      &euro;
                    </dd>
                  </CompletedField>

                  {quote.payment_frequency === 2 && (
                    <CompletedField>
                      <dt>Da Pagare</dt>
                      <dd>
                        {quote.amount_paid === quote.amount
                          ? '0.00'
                          : (
                            Math.ceil(quote.amount * 100) / 100
                            - quote.amount_paid
                          ).toFixed(2)}
                        {' '}
                        &euro;
                      </dd>
                    </CompletedField>
                  )}

                  {/* Totale (temporarily hidden)
<CompletedField className="full total">
                    <dt>Totale</dt>
                    <dd>
                      {quote.amount.toFixed(2)}
                      {' '}
                      &euro;
                    </dd>
                  </CompletedField>
*/}

                  <CompletedField>
                    <dt>Provvigioni</dt>
                    <dd>
                      {quote.commision.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      {' '}
                      &euro;
                    </dd>
                  </CompletedField>

                  {quote.company_id === 16 && (
                    <CompletedField className="full">
                      <dt>Informazioni Prodotto</dt>
                      <dd>
                        <span
                          className="text-decoration-underline text-primary cursor-pointer"
                          onClick={() => downloadResourceDocs(13)}
                        >
                          Informazioni Precontrattuali
                        </span>
                      </dd>
                    </CompletedField>
                  )}
                </CompletedFieldGrid>
              </CompletedCard>
            </div>
          </div>
        </div>

        {/* Documents Section */}
        <div className="section-container">
          <CompletedCard className="polizze-emessa-status-step-four">
            <CompletedCardHeader>
              <CompletedCardIcon>
                <FontAwesomeIcon icon={faShieldAlt} />
              </CompletedCardIcon>
              <CompletedCardTitle>Documenti</CompletedCardTitle>
            </CompletedCardHeader>

            <ol className="list-group list-group-numbered">
              {documents.filter((dr) => (dr.document_type_id !== 34 && dr.document_type_id !== 35 && dr.document_type_id !== 36 && dr.document_type_id !== 37 && dr.document_type_id !== 38 && dr.document_type_id !== 39 && dr.document_type_id !== 40 && dr.document_type_id !== 41)).map((document, index) => (
                <li
                  className="list-group-item d-flex justify-content-between align-items-start position-relative"
                  key={index}
                >
                  <div className="ms-2 me-auto">
                    <div className="fw-bold mb-2">
                      {document.document_type.name}
                    </div>
                    <div className="d-flex align-items-center justify-content-between">
                      <img
                        src={pdfIMG}
                        className="img-fluid"
                        width="25"
                        alt="PDF"
                      />
                      <div className="mx-2">
                        <h5 className="h6 mb-0">
                          {document.original_filename}
                        </h5>
                      </div>
                      <div className="d-flex align-items-center justify-content-center">
                        <button
                          className="doc-btn border-0 bg-transparent"
                          onClick={() => downloadDocument(document.id)}
                        >
                          <img src={downloadIMG} width="25" alt="" />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
              ))}
            </ol>
          </CompletedCard>
        </div>

        {quote.initial_quotation !== undefined && (
          <div className="section-container">
            <CompletedCard className="">
              <CompletedCardHeader>
                <CompletedCardIcon>
                  <FontAwesomeIcon icon={faFileAlt} />
                </CompletedCardIcon>
                <CompletedCardTitle>Documenti nel preventivo iniziale</CompletedCardTitle>
              </CompletedCardHeader>

              <ol className="list-group list-group-numbered">
                {quote.initial_quotation.insurance_request.documents.map(
                  (document, index) => (
                    <li
                      className="list-group-item d-flex justify-content-between align-items-start"
                      key={index}
                    >
                      <div className="ms-2 me-auto">
                        <div className="fw-bold mb-2">
                          {document.document_type.name}
                        </div>
                        <div className="d-flex align-items-center justify-content-between">
                          <img
                            src={pdfIMG}
                            className="img-fluid"
                            width="25"
                            alt="PDF"
                          />
                          <div className="mx-2">
                            <h5 className="h6 mb-0">
                              {document.original_filename}
                            </h5>
                          </div>
                          <div className="d-flex align-items-center justify-content-center">
                            <button
                              className="doc-btn border-0 bg-transparent"
                              onClick={() => downloadDocument(document.id)}
                            >
                              <img src={downloadIMG} width="25" alt="" />
                            </button>
                          </div>
                        </div>
                      </div>
                      <div>
                        {document.signable_document === 1
                          && document.is_signed_valid ? (
                            <span className="badge bg-primary rounded-pill me-1">
                              Firmato
                            </span>
                          ) : (
                            <span className="badge bg-info rounded-pill me-1">
                              Non Richiede Firma
                            </span>
                          )}
                      </div>
                    </li>
                  ),
                )}
                {quote.initial_quotation.documents.map((document, index) => (
                  <li
                    className="list-group-item d-flex justify-content-between align-items-start"
                    key={index}
                  >
                    <div className="ms-2 me-auto">
                      <div className="fw-bold mb-2">
                        {document.document_type.name}
                      </div>
                      <div className="d-flex align-items-center justify-content-between">
                        <img
                          src={pdfIMG}
                          className="img-fluid"
                          width="25"
                          alt="PDF"
                        />
                        <div className="mx-2">
                          <h5 className="h6 mb-0">
                            {document.original_filename}
                          </h5>
                        </div>
                        <div className="d-flex align-items-center justify-content-center">
                          <button
                            className="doc-btn border-0 bg-transparent"
                            onClick={() => downloadDocument(document.id)}
                          >
                            <img src={downloadIMG} width="25" alt="" />
                          </button>
                        </div>
                      </div>
                    </div>
                    <div>
                      {document.signable_document === 1
                        && document.is_signed_valid ? (
                          <span className="badge bg-primary rounded-pill me-1">
                            Firmato
                          </span>
                        ) : (
                          <span className="badge bg-info rounded-pill me-1">
                            Non Richiede Firma
                          </span>
                        )}
                    </div>
                  </li>
                ))}
              </ol>
            </CompletedCard>
          </div>
        )}

        {/* After Sale Section */}
        <CompletedQuoteScreenAutoAfterSale
          quote={quote}
          document_types={document_types}
          v2
        />
      </TutelaLegaleCompletedScreenStyles>
    </>
  );
}

export default CollisioneCompletedScreen;
